<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">

    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">DATA COLLECTION</li>
            </ol>
        </nav>
    </div>
</div>

<div class="card">
    <div class="card-body">
        <div class="input-group mb-3">
            <input type="text" class="form-control" [(ngModel)]="feed_token" placeholder="Feed Token" aria-label="Feed Access token" aria-describedby="button-feed-token">
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" id="button-feed-token" (click)="saveToken()">Save</button>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-2">
                <input type="date" name="" class="form-control mr" [(ngModel)]="filter_params.selected_date">
            </div>
            <div class="col-2">
                <select class="form-select" [(ngModel)]="filter_params.selected_category" (change)="onCategoryChanged()" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let category of categories" [value]="category.index"> {{ category.display_name }}</option>
                </select>
            </div>
            <div class="col-8">
                <button type="button" class="btn btn-primary" (click)="runDataCollection()">Run</button>
                <button type="button" class="btn btn-primary ms-1" (click)="stopDataCollection()">Stop</button>
                <button type="button" class="btn btn-primary ms-1" (click)="checkRunStatus()">Run Status</button>
                <button type="button" class="btn btn-primary ms-1" (click)="checkDataCollection()">Check Data</button>
                <button type="button" class="btn btn-primary ms-1" (click)="splitCategory()">Split</button>
                <button type="button" class="btn btn-primary ms-1" (click)="archiveData()">Archive</button>
                <button type="button" class="btn btn-primary ms-1" (click)="stopArchiveData()">Stop Archive</button>
                <button type="button" class="btn btn-primary ms-1" (click)="checkArchiveStatus()">Archive Status</button>
            </div>
        </div>
        <div>
            <table class="table table-striped">
                <!-- <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" *ngFor="let c of state.short.cols">{{ c }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let r of state.short.rows">
                        <th scope="row">{{ r['#'] }}</th>
                        <td *ngFor="let c of state.short.cols">{{ r[c] }}</td>
                    </tr>
                </tbody> -->
                <thead>
                    <tr>
                        <th>Category</th>
                        <th>1m</th>
                        <th>1D</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of rows">
                        <td>{{ row.category }}</td>
                        <td>{{ row.m_count }}</td>
                        <td>{{ row.d_count }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>